













































import BaseComponent from '@/components/base-component.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { IdNomeDTO } from '@/interfaces/base-dto';
import { getAprovationScheduleDetails } from '@/services/prescription';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class PrescriptionApprovalScheduleModal extends BaseComponent {
  @Prop()
  private modalOpen: boolean;

  @Prop()
  private idPrescricao: number;

  @Prop()
  private dataPrescricao: Date;

  private dataPrescricaoShow: string;

  loading = false;
  hour = null;
  group: IdNomeDTO[] = [];
  details = null;
  ids = [];

  public form: any = {
    valid: false,
    rules: {
      horario: [(v) => (v && v.length == 5) || 'Informe o horário de envio para produção'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    this.onIdPrescricaoChange(this.idPrescricao);
    this.onDataPrescricaoChange(this.dataPrescricao);
  }

  @Watch('idPrescricao')
  onIdPrescricaoChange(id) {
    if (!id) {
      return;
    }
    this.loading = true;

    getAprovationScheduleDetails(id).subscribe(
      (res) => {
        this.loading = false;
        this.group = res.grupo;
        this.hour = res.horarioConfig;
        this.details = res;
      },
      (error) => {
        this.loading = false;
        this.showToastApiError(error);
      }
    );
  }

  @Watch('dataPrescricao')
  onDataPrescricaoChange(d) {
    if (!d) {
      this.dataPrescricaoShow = null;
      return;
    }
    if (Array.isArray(d)) {
      this.dataPrescricaoShow = dateFormat(d[0]);
    } else {
      this.dataPrescricaoShow = dateFormat(d);
    }
  }

  public closeForm(): void {
    this.$emit('close');
  }

  public save(): void {
    if (!this.ids.find(id => id == this.idPrescricao)) {
      this.ids.push(this.idPrescricao);
    }
    this.$emit('save', this.hour, this.ids);
  }

  selectAll() {
    this.ids = this.group.map((g) => g.id);
  }

  removeAllSelected() {
    this.ids = [];
  }

}
